<template>
  <div class="content-main-body">
    <charts
      v-if="chartWindowVisible"
      :data="data"
      @close="chartWindowVisible = false"
    >
    </charts>
    <div
      class="settings-main__overlay"
      v-show="$loader.isLoading('getApplicationDevices')"
    >
      <spinner
        line-fg-color="#313942"
        line-bg-color="#eee"
        message="IoT Objekte werden geladen"
        :spacing="10"
        :size="16"
      ></spinner>
    </div>
    <div class="mobile-content-header">
      <div class="row" v-show="application.id">
        <div class="col-md-8 mobilehide">
          <div class="content-header">
            {{ application.title }}
          </div>
          <!--div class="content-information">
          {{ application.description }}<br /><br />
          <Reporting &amp; Auswertungen: <a href="https://grafana.stage.niota.io/dashboard/db/schule-bramfelder-dorfplatz" target="_blank">hier klicken</a>
        </div-->
        </div>
        <div class="col-md-12 desktophide">
          <div style="display: flex;">
            <div class="content-header w95">
              {{ application.title }}
            </div>
            <div @click="unselectItem()">
              <span class="close__circle">
                x
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12 desktophide">
          <div class="content-information">
            <el-switch
              class="contentViewSwitch"
              v-model="contentViewSwitch"
              active-color="#003871"
              inactive-color="#003871"
              active-text=""
              inactive-text="Kacheln / Tabelle"
            >
            </el-switch>
          </div>
        </div>
        <!--div class="col-md-12 desktophide">
        <div class="content-information">
          {{ application.description }}<br /><br />
          < Reporting &amp; Auswertungen: <a href="https://grafana.stage.niota.io/dashboard/db/schule-bramfelder-dorfplatz" target="_blank">hier klicken</a>
        </div>
      </div-->
        <div class="col-md-4 mobilehide">
          <div class="content-header">
            <el-switch
              class="contentViewSwitch"
              v-model="contentViewSwitch"
              active-color="#003871"
              inactive-color="#003871"
              active-text="Tabelle"
              inactive-text="Kacheln"
            ></el-switch>
          </div>
        </div>
      </div>
      <div class="row mobilehide" v-show="application.id">
        <div class="col-md-4"></div>
        <div class="col-md-8 content-buttons">
          <el-button
            plain
            icon="el-icon-location-outline"
            class="sbh-button-light"
            style=""
            @click="showAllDevicesOnMap"
          >
            Kartenansicht
          </el-button>
          <el-button
            plain
            icon="el-icon-location-outline"
            v-show="alertTable.length"
            class="sbh-button-alert"
            style=""
            @click="showAlertsOnMap"
          >
            Alarm-Karte
          </el-button>
        </div>
      </div>
      <div class="desktophide" v-show="application.id">
        <div class="mobile-buttons">
          <div class="">
            <el-button
              plain
              icon="el-icon-location-outline"
              v-show="alertTable.length"
              class="sbh-button-light"
              style=""
              @click="showAllDevicesOnMap"
            >
              Kartenansicht
            </el-button>
          </div>
          <div class="content-buttons">
            <el-button
              plain
              icon="el-icon-location-outline"
              v-show="alertTable.length"
              class="sbh-button-alert"
              style=""
              @click="showAlertsOnMap"
            >
              Alarm-Karte
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="tiles row" v-show="application.title" v-if="!contentViewSwitch">
      <div class="tile-wrapper">
        <div class="clear-tile">
          <div class="row">
            <!-- Loop here -->
            <div
              class="col col-xs-12 col-sm-6 col-md-4 col-lg-3 minW270"
              v-for="tile in tilesTable"
              :key="tile.id"
            >
              <!--div
              class="col col-xs-12 col-sm-12 col-md-12 col-lg-12 level-panel"
              v-for="(item, index) in tilesTable"
              :key="index"
            >
            <h1>Ebene - {{ index }}</h1>
              <div
                class="col col-xs-12 col-sm-6 col-md-4 col-lg-3 minW270"
                v-for="tile in item"
                :key="tile.id"
              -->
              <!--el-tooltip
                :content="tile.tooltip"
                placement="top"
                effect="light"
                :open-delay="1500"
                :hide-after="3500"
              -->
              <div class="small-tile-wrapper">
                <!-- for level .small-tile-wrapper-level -->
                <div
                  class="small-tile"
                  :class="tile.tileData[0].cssIconClass"
                  @click.capture="showTileDevicesOnMap(tile.tileData)"
                >
                  <p class="small-tile-title hover">
                    <span
                      v-if="tile.tileData[0].tile_name"
                      class="tile-titel"
                      >{{ tile.tileData[0].tile_name }}</span
                    >
                    <span v-else>{{ tile.tileData[0].title }}</span>
                  </p>
                  <p
                    v-show="!tile.hasAlert"
                    class="bigSuccess hover float-right"
                  >
                    <!--label class="toggleButton" style="padding-left: 4px;">
                        <animated-check :toggle="!tile.hasAlert"></animated-check>
                      </label-->
                    <i
                      v-if="tile.tileData[0].tile_name"
                      class="el-icon-success tile-icon-big-ok"
                    ></i>
                    <span v-else>
                      <i class="el-icon-error tile-icon-big-error"></i>
                    </span>
                  </p>
                  <div
                    class="messages-overflow col-md-12"
                    v-show="tile.hasAlert"
                  >
                    <transition-group name="fade">
                      <div
                        v-for="aDevice in tile.tileData"
                        :key="aDevice.id"
                        v-show="tile.hasAlert"
                        class="hover"
                        style="display: flex;"
                        @click="tableRowClicked(aDevice)"
                      >
                        <span v-if="checkCondition(aDevice)">
                          <i
                            v-show="aDevice.hasAlert"
                            class="fas fa-times-circle tile-icon-error"
                          ></i>
                        </span>
                        <span v-else>
                          <i
                            v-show="aDevice.hasAlert"
                            class="fas fa-exclamation-circle tile-icon-warning"
                          ></i>
                        </span>
                        <el-tooltip
                          class="item"
                          effect="light"
                          :content="aDevice.description || aDevice.title"
                          placement="top"
                          :open-delay="500"
                        >
                          <div
                            v-if="aDevice.hasAlert"
                            class="tile-icon-message circle-message truncate"
                          >
                            {{ aDevice.parsedData.output }} -
                            {{ aDevice.title }}
                            <span v-if="aDevice.description">
                              {{ aDevice.description }}
                            </span>
                            <span v-else> - {{ aDevice.title }} </span>
                          </div>
                        </el-tooltip>
                      </div>
                    </transition-group>
                    <br />
                  </div>
                </div>
              </div>
              <!--/el-tooltip-->
            </div>
            <!--/div-->
          </div>
        </div>
      </div>
    </div>

    <div class="sbh-sensor-table" v-show="application.title" v-else>
      <sensor-table-main
        ref="navbar"
        :tableData="alertTable"
        :tableType="tableTypeMessages"
        :alertTable="true"
        :tableHeight="alertTableHeight"
        @show3DMapEvent="show3DMapEvent"
        @tableRowClicked="tableRowClicked"
        @deviceDetailRequested="deviceDetailRequested"
        @buildChartdata="buildChartdata"
        v-if="alertTable.length"
      ></sensor-table-main>
      <el-alert
        title="Keine Alarme oder Warnmeldungen vorhanden"
        type="success"
        v-else
      ></el-alert>
      <div class="separator-button-line mobilehide">
        <!--el-button
          plain
          icon="el-icon-arrow-down"
          v-show="devices.length"
          class="sbh-button-light w100"
          @click="showAllSensorsTable = !showAllSensorsTable"
        >
          Alle Sensoren anzeigen!
        </el-button-->
      </div>
      <sensor-table-main
        ref="navbar"
        :tableData="devices"
        :tableType="tableTypeData"
        :alertTable="false"
        :tableHeight="tableHeight"
        @show3DMapEvent="show3DMapEvent"
        @tableRowClicked="tableRowClicked"
        @deviceDetailRequested="deviceDetailRequested"
        @buildChartdata="buildChartdata"
      ></sensor-table-main>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import SensorTableMain from "./ui-elements/sensorTableMain";
import Charts from "./window/ChartsWindow";
//import AnimatedCheck from "./elements/AnimatedCheck";
import ApiService from "../services/api-service";
import ChartService from "../services/chart-service";

export default {
  name: "contentMain",
  components: {
    Spinner,
    SensorTableMain,
    Charts
    //  AnimatedCheck
  },
  props: {
    application: Object,
    devices: Array
  },
  computed: {
    alertTable() {
      return this.$store.state.alertTable;
    },
    tilesTable() {
      return this.$store.state.tilesTable;
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.$bus.on("buildChartdata", this.buildChartdata);
  },
  data: () => ({
    contentViewSwitch: false,
    showAllSensorsTable: false,
    markers3DMap: [],
    show3DMapOnDisplay: false,
    tableTypeData: "data",
    tableTypeMessages: "messages",
    chartWindowVisible: false,
    data: null,
    alertTableHeight: "100px",
    tableHeight: "350px"
  }),
  methods: {
    show3DMapFromTile(data) {
      this.show3DMapOnDisplay = true;
      this.markers3DMap = data.tileData;
    },
    show3DMapEvent(data) {
      this.show3DMapOnDisplay = true;
      this.markers3DMap = data;
    },
    showAlertsOnMap() {
      this.$emit("alertsOnMapClicked", this.alertTable);
    },
    showTileDevicesOnMap(tileDevices) {
      this.$emit("alertsOnMapClicked", tileDevices);
    },
    showAllDevicesOnMap() {
      this.$emit("alertsOnMapClicked", this.devices);
    },
    tableRowClicked(row) {
      this.$emit("tableRowClicked", row);
    },
    deviceDetailRequested(row) {
      this.$emit("deviceDetailRequested", row);
    },
    unselectItem() {
      this.$emit("unselectItem");
    },
    buildChartdata(device) {
      let body = {
        limit: 100000,
        from: "7d"
      };
      let data = {};
      if (device.tile_name === "Büro") {
        body.from = "1d";
      }
      this.$store.state.device = device;
      ApiService.getParsedPackets(device.id, body)
        .then(packets => {
          data = ChartService.parseDataForChart(device, packets, body);
          data.title = device.title + " - " + device.description;
          if (data.keys.length) {
            this.showChart(data);
            this.$loader.endLoading("getParsedPackets");
          } else {
            this.$notify({
              type: "error",
              message: `Keine Datenpakete gefunden!`,
              position: "bottom-left"
            });
          }
        })
        .catch(response => {
          this.loading = false;
          this.$notify({
            type: "error",
            message: `Fehler beim laden des Packets: ${response}`,
            position: "bottom-left"
          });
        });
    },
    showChart(data) {
      /*this.chartdata.labels = data.labels;
      this.chartdata.datasets[0].data = data.data;
      this.chartdata.datasets[0].label = data.title;*/
      this.data = data;
      this.chartWindowVisible = true;
    },
    handleResize() {
      let width = window.innerWidth;
      let height = window.innerHeight;
      if (width <= 768) {
        this.alertTableHeight = "auto";
        this.tableHeight = "auto";
      } else {
        this.tableHeight = height - 470 + "px";
        this.alertTableHeight = "100px";
      }
    },
    checkCondition(device) {
      if (
        device.cssIconClass !== "brandschott" &&
        device.cssIconClass !== "parking" &&
        device.cssIconClass !== "window"
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
